<template>
  <div class="group-relationship-application">
    <a-card class="margin-top-20">
      <a-form-model ref="form" :model="form" :rules="rules">
        <a-row :gutter="{ xs: 8, sm: 16, md: 24 }">
          <a-col :lg="8" :md="12" :sm="24">
            <a-form-model-item label="子公司ID" prop="id">
              <a-auto-complete
                placeholder="请输入子公司ID"
                @select="handleSelect"
                @search="handleSearch"
                v-model="form.id"
                :allow-clear="true"
              >
                <template slot="dataSource">
                  <a-select-option
                    v-for="item in compList"
                    :key="item.code"
                    :value="JSON.stringify(item)"
                  >
                    {{ item.code }}
                  </a-select-option>
                </template>
              </a-auto-complete>
            </a-form-model-item>
          </a-col>
          <a-col :lg="8" :md="12" :sm="24">
            <a-form-model-item label="子公司名称" prop="name">
              <a-auto-complete
                placeholder="请输入子公司名称"
                @select="handleSelect"
                @search="handleSearch"
                v-model="form.name"
                :allow-clear="true"
              >
                <template slot="dataSource">
                  <a-select-option
                    v-for="item in compList"
                    :key="item.code"
                    :value="JSON.stringify(item)"
                  >
                    {{ item.name }}
                  </a-select-option>
                </template>
              </a-auto-complete>
            </a-form-model-item>
          </a-col>
          <a-col :lg="8" :md="12" :sm="24">
            <a-form-model-item label="关系类型" prop="type">
              <a-select v-model="form.type">
                <a-select-option
                  v-for="item in RELATION_TYPE_LIST"
                  :key="item.value"
                >
                  {{ item.label }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col style="text-align:center;">
            <a-form-model-item>
              <a-button type="primary" @click="handleSubmit">
                下一步
              </a-button>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </a-card>
  </div>
</template>

<script>
import { getCustomerList } from './api'
import { RELATION_TYPE_LIST } from './const'
export default {
  data() {
    //这里存放数据
    return {
      form: {
        id: (this.$route.query && this.$route.query.code) || '',
        name: '',
        type: '',
      },
      rules: {
        id: [
          {
            required: true,
            message: '请输入企业ID',
            trigger: 'blur',
          },
        ],
        name: [
          {
            required: true,
            message: '请输入企业名称',
            trigger: 'blur',
          },
        ],
        type: [
          {
            required: true,
            message: '请选择信用类型',
            trigger: 'change',
          },
        ],
      },
      RELATION_TYPE_LIST,
      compList: [],
    }
  },
  components: {},

  //方法集合
  methods: {
    handleSelect(value) {
      const selectedValue = JSON.parse(value)
      this.form.id = selectedValue.code
      this.form.name = selectedValue.name
      this.compList = []
    },

    async handleSearch(value) {
      if (!value.trim()) {
        return
      }
      try {
        const { data } = await getCustomerList(value)
        this.compList = data
      } catch (error) {
        console.error(error)
      }
    },
    async handleSubmit() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            this.$router.push({
              path: `/customer-credit/relationship-detail/${this.form.id}`,
              query: {
                type: this.form.type,
              },
            })
          } catch (error) {
            console.error(error)
          }
        } else {
          return false
        }
      })
    },
  },
  //生命周期 - 创建完成（访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（访问DOM元素）
  async mounted() {
    const code = this.$route.query && this.$route.query.code
    if (code) {
      try {
        const { data } = await getCustomerList(code)
        const selectedValue = data && data.length && data[0]
        this.form.id = selectedValue.code
        this.form.name = selectedValue.name
      } catch (error) {
        console.error(error)
      }
    }
  },
}
</script>
<style scoped>
/* @import url(); 引入css类 */
</style>
